import React from 'react';

import styles from "./RelatedLink.module.css";
import Link from 'next/link';

const RelatedLink = (props) => {
  const { urlType, queryParameters, noFollow, isNewTab, copy, url } = props;

  const getLinkUrl = () => {
    let linkUrl = url;
    if (queryParameters) {
      linkUrl += '?' + queryParameters;
    }
    return linkUrl;
  };
  return (
    <div className={styles["related-link"]}>
      <span className={styles["vertical-bar"]}></span>
      <div>
        <strong className="related-link-type">{urlType}</strong>
        <div className={styles["related-link-title"]}>
          <Link
            href={getLinkUrl()}
            target={isNewTab ? '_blank' : '_self'}
            rel={
              noFollow ? 'nofollow noopener noreferrer' : 'noopener noreferrer'
            }
            className={styles["related-link-copy"]}
          >
            <span dangerouslySetInnerHTML={{ __html: copy }} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RelatedLink;
